var render = function render(){var _vm=this,_c=_vm._self._c;return _c('benefit-notification-box-base',{attrs:{"icon-path":_vm.iconText,"description":_vm.description,"title":_vm.title,"color":_vm.color,"link-text":_vm.linkText},on:{"link-click":_vm.handleLinkClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }